<template>
    <div v-if="program" class="pa-3 white lighten-1">
        <div class="pa-2 white lighten-3">
            <v-card class="card--flex-toolbar">
                <v-card-text class="pa-0">
                    <v-form ref="form">
                        <v-card-title class="grey lighten-3 pa-2">
                            <h3 class="secondary--text">
                                {{ $t('program.update.filter.film_year') }}
                            </h3>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <!-- Film Year  -->
                        <v-card-title>
                            <v-flex xs12>
                                <v-combobox
                                v-model="program.filters.film_years"
                                :items="years"
                                :label="$t('program.update.filter.select_film_years')"
                                multiple
                                chips
                                @input="resetCombobox"
                                :search-input.sync="yearSearchInput"
                                ></v-combobox>
                            </v-flex>
                        </v-card-title>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
        <!-- Program Filter Film Sectionm -->
        <div class="pa-2 white lighten-3">
            <v-card class="card--flex-toolbar">
                <v-card-text class="pa-0">
                    <v-form ref="form">
                        <v-card-title class="grey lighten-3 pa-2">
                            <h3 class="secondary--text">
                                {{ $t("program.event.film_section") }}
                            </h3>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <!-- Film Section  -->
                        <v-card-title class="text-lg-right">
                            <v-spacer></v-spacer>
                            <v-flex xs12 md6 lg6>
                                <v-combobox
                                    :search-input.sync="film_section_search"
                                    v-model="program.filters.film_sections"
                                    :items="film_sections"
                                    chips
                                    color="primary"
                                    :label="$t('program.update.filter.add_film_section')"
                                    multiple
                                    persistent-hint
                                    item-text="name"
                                    item-value="name"
                                    :return-object="false"
                                    >
                                    <template v-slot:no-data>
                                        <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                            No results matching<strong v-if="film_section_search">&nbsp;{{ film_section_search }}</strong>. Press <kbd>enter</kbd> to create a new one
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-tile-content v-text="data.item.name"></v-list-tile-content>
                                        </template>
                                        <template v-else>
                                        <v-list-tile-content>
                                            <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                        </v-list-tile-content>
                                        </template>
                                    </template>
                                    <template v-slot:selection="data">
                                       
                                    </template>
                                </v-combobox>
                            </v-flex>
                        </v-card-title>
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th v-for="header in table_headers_film_section" :key="header.text" scope="col">{{ header.text }}</th>
                                </tr>
                            </thead>
                            <draggable v-model="program.filters.film_sections" tag="tbody">
                                <tr class="table-row draggable-row" v-for="(item, index) in program.filters.film_sections" :key="item">
                                    <td><v-icon class="mr-2">mdi-drag</v-icon></td>
                                    <td class="text-xs-left">{{ index + 1 }}</td>
                                    <td class="text-xs-left">{{ item }}</td>
                                    <td class="text-xs-left">
                                        <a v-if="isEditable('film_sections', item)" @click="updateTag('film_sections', item)" class="mr-2"><u>{{ $t('program.filter.action.edit') }}</u></a>
                                        <a @click="removeTag('film_sections', item)" class="ml-2"><u>{{ $t('program.filter.action.remove') }}</u></a>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
        <!-- Program Filter Film Sectionm -->

        <!-- Program Filter Film Type -->
        <div class="pa-2 white lighten-3">
            <v-card class="card--flex-toolbar">
                <v-card-text class="pa-0">
                    <v-form ref="form">
                        <v-card-title class="grey lighten-3 pa-2">
                            <h3 class="secondary--text">
                                {{ $t("program.event.film_type") }}
                            </h3>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <!-- Film Section  -->
                        <v-card-title class="text-lg-right">
                            <v-spacer></v-spacer> <v-spacer></v-spacer> <v-spacer></v-spacer>
                            <v-flex xs12 md6 lg6 >
                                <v-combobox
                                    :search-input.sync="film_type_search"
                                    v-model="program.filters.film_types"
                                    :items="film_types"
                                    chips
                                    color="primary"
                                    :label="$t('program.update.filter.add_film_type')"
                                    multiple
                                    persistent-hint
                                    item-text="name"
                                    item-value="name"
                                    :return-object="false"
                                    >
                                    <template v-slot:no-data>
                                        <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                            No results matching<strong v-if="film_type_search">&nbsp;{{ film_type_search }}</strong>. Press <kbd>enter</kbd> to create a new one
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                        </template>
                                        <template v-else>
                                        <v-list-tile-content>
                                            <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                        </v-list-tile-content>
                                        </template>
                                    </template>
                                    <template v-slot:selection="data">
                                    </template>
                                </v-combobox>
                            </v-flex>
                        </v-card-title>
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th v-for="header in table_headers_film_types" :key="header.text" scope="col">{{ header.text }}</th>
                                </tr>
                            </thead>
                            <draggable v-model="program.filters.film_types" tag="tbody">
                                <tr class="table-row draggable-row" v-for="(item, index) in program.filters.film_types" :key="item">
                                    <td scope="row"><v-icon class="mr-2">mdi-drag</v-icon></td>
                                    <td scope="row" class="text-xs-left">{{ index + 1 }}</td>
                                    <td scope="row" class="text-xs-left">{{ item }}</td>
                                    <td scope="row" class="text-xs-left">
                                        <a v-if="isEditable('film_types', item)" @click="updateTag('film_types', item)" class="mr-2">
                                            <u>{{ $t('program.filter.action.edit') }}</u>
                                        </a>
                                        <a @click="removeTag('film_types', item)" class="ml-2">
                                            <u>{{ $t('program.filter.action.remove') }}</u>
                                        </a>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
        <!-- Program Filter Type Sectionm -->
        <v-layout row wrap>
            <!-- Submit and Cancel Buttons -->
            <v-flex xs12 class="pt-3 text-lg-right">
                <v-btn color="grey" dark @click="cancel">{{ $t("program.update.cancel") }}</v-btn>
                <v-btn color="primary" @click="save">{{ $t("program.update.save") }}</v-btn>
            </v-flex>
        </v-layout>
        <ConfirmationDialogBox
        v-if="filterEditDialog.active && filterEditDialog.tag.name"
        :title="`Edit ${filterEditDialog.type}`"
        :dialog="filterEditDialog.active"
        :yesBtnText="'Update'"
        :noBtnText="'Cancel'"
        @confirm="doUpdateTag"
        @cancel="resetFilterEditDialog"
        >
            <v-text-field
                v-model="filterEditDialog.tag.name"
                :rules="[rules.required]"
            ></v-text-field>
        </ConfirmationDialogBox>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import i18n from "@/i18n";
import ConfirmationDialogBox from "@/components/dialogBox/DynamicConfirmationBox";
import rules from "@/validation";
import draggable from 'vuedraggable';


export default {
    name: 'ProgramFilters',
    props: {
        program: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            rules,
            total: 0,
            table_headers_film_section: [
                {
                    text:'',
                    align: "left",
                    sortable: false,
                    value: "",
                },
                {
                    text: i18n.t("rms.table.header.s.n"),
                    align: "left",
                    sortable: false,
                    value: "",
                },
                {
                    text: i18n.t("program.event.table.header.film_section"),
                    align: "left",
                    sortable: false,
                },
                {
                    text: i18n.t("rms.table.header.action"),
                    sortable: false,
                    align: "",
                },
            ],
            table_headers_film_types: [
                {
                    text:'',
                    align: "left",
                    sortable: false,
                    value: "",
                },
                {
                    text: i18n.t("rms.table.header.s.n"),
                    align: "left",
                    sortable: false,
                    value: "",
                },
                {
                    text: i18n.t("program.event.table.header.film_type"),
                    align: "left",
                    sortable: false,
                },
                {
                    text: i18n.t("rms.table.header.action"),
                    sortable: false,
                    align: "",
                },
            ],
            rowsPerPageItems: [5, 10, 25, 50, 100],
            pagination: {
                sortBy: "start_date",
                descending: true,
                page: 1,
                rowsPerPage: 10,
            },
            film_section_search: null,
            film_type_search: null,
            search:null,
            yearSearchInput:null,
            filterEditDialog:{
                active:false,
                value:null,
                type:null,
                tag:null,
            }
        }
    },
    components: {
        ConfirmationDialogBox,
        draggable
    },
    computed: {
        ...mapFields("tag", {
            film_sections: "film_sections",
            film_types: "film_types"
        }),
        years(){
            var currentYear = new Date().getFullYear();
            var years = [];
            
            // Generate past 100 years
            for (var i = currentYear - 100; i < currentYear; i++) {
                years.push(i);
            }
            
            // Generate future 100 years
            for (var j = currentYear; j <= currentYear + 100; j++) {
                years.push(j);
            }
            
            return years;
        }
    },
    methods:{
        save(){
            this.$emit("update");
        },
        cancel() {
            this.$emit("cancel");
        },
        removeTag(type, toBeRemovedTag){
            if(this.program.filters[type] && toBeRemovedTag){
                this.program.filters[type] = this.program.filters[type].filter((tag) => tag !== toBeRemovedTag);
                return this.program.filters[type];
            }
        },
        updateTag(type, toBeUpdatedTag){
            if(!type || !toBeUpdatedTag){
                return;   
            }
            this.filterEditDialog.value = toBeUpdatedTag;
            this.filterEditDialog.tag = this.isEditable(type, toBeUpdatedTag);
            this.filterEditDialog.type = type.replace(/_/g, " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
            this.filterEditDialog.active = true;
        },
        isEditable(type, toBeUpdatedTag) {
            if (this[type] && toBeUpdatedTag) {
                return this[type].find(tag => tag.name === toBeUpdatedTag);
            }
            return null; // Return null if not found or invalid input
        },
        async doUpdateTag(){
            try {
                var response = await this.$store.dispatch("tag/update", this.filterEditDialog.tag);
                await this.updateTagInList(response.tag.type, response.tag);
                this.$store.dispatch("app/showMessage", {
                    message: `${this.filterEditDialog.type} updated successfully`,
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
                });
            } catch (error) {
                console.error(error);
            }finally{
                this.resetFilterEditDialog();
            }
        },
        
        async updateTagInList(type, updatedTag)
        {
            if(updatedTag)
            {
                if(this.program.filters[type]){
                    let pIndex = this.program.filters[type].findIndex(pTag => pTag === this.filterEditDialog.value);
                    if (pIndex !== -1) {
                        this.$set(this.program.filters[type], pIndex, updatedTag.name); // Reactive update in Vue
                    }
                }

                if(this[type]){
                    let index = this[type].findIndex(tag => tag.id === updatedTag.id);
                    if (index !== -1) {
                        this.$set(this[type], index, updatedTag); // Reactive update in Vue
                    }
                }
            }
        },
        resetFilterEditDialog(){
            this.filterEditDialog.tag = null;
            this.filterEditDialog.type = '';
            this.filterEditDialog.active = false;
            this.filterEditDialog.value = '';
        },
        resetCombobox(){
            setTimeout(() => {
                this.yearSearchInput = null;
            }, 2000);
        }
    }
}
</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.table th {
  background-color: #fff;
  color: black;
  text-align: left;
  padding: 12px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.table td {
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.table-striped tbody tr {
  background-color: #fff;
}

.table-striped tbody tr:hover {
  background-color: #f9f9f9;
  cursor: move;
}

.draggable-row {
  cursor: grab;
}

.v-icon {
  vertical-align: middle;
  color: #666;
}
</style>